import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  items: any;
  currentId: any;
  onItemClick: (index: number) => void;
}

function Chooser({ items, currentId, onItemClick }: Props) {
  return (
    <Wrapper>
      {items &&
        items.map((item, i) => (
          <ChooserItem
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => onItemClick(item.category_id)}
            active={currentId === item.category_id}
            isFirst={i === 0}
            isLast={i === items.length - 1}
            key={item.category_id}
          >
            {item.category_name}
          </ChooserItem>
        ))}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(345)};
  border: ${({ theme }) => theme.borders.product};
  border-right: 0;
  margin-right: 0;

  transition: all 0.2s ease;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: ${rem(6)};
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: ${rem(16)};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: gray;
    border-radius: ${rem(16)};
  }

  @media only screen and (max-width: 1740px) {
    flex-flow: row;
    border: 0;
    margin-bottom: ${rem(12)};
    overflow: auto;
    max-width: initial;
  }
`;

interface ChooserItemProps {
  isLast?: boolean;
  isFirst?: boolean;
  active?: boolean;
  theme: any;
}

const ChooserItem: any = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(18)};
  font-weight: ${({ active }: ChooserItemProps) => (active ? 500 : 400)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ active, theme }: ChooserItemProps) =>
    active ? theme.colors.backgroundProducts : theme.colors.white};
  padding: ${rem(20)} ${rem(32)};
  border-right: ${({ active, theme }: ChooserItemProps) =>
    active ? 0 : theme.borders.product};
  border-bottom: ${({ isLast, active, theme }: ChooserItemProps) =>
    active && !isLast ? theme.borders.product : 0};
  border-top: ${({ isFirst, active, theme }: ChooserItemProps) =>
    active && !isFirst ? theme.borders.product : 0};
  cursor: pointer;
  min-height: ${rem(64)};
  flex: 1 1 auto;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundProducts};
  }

  @media only screen and (max-width: 1740px) {
    white-space: pre;
    border: 0;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0;
    padding-bottom: ${rem(8)};
    margin-right: ${rem(32)};
    min-height: initial;
    font-size: ${rem(20)};
    line-height: ${rem(28)};
    color: ${({ theme, active }: ChooserItemProps) =>
      active ? theme.colors.primary : theme.colors.textPrimary};
    justify-content: flex-start;

    &:last-child {
      padding-right: ${rem(24)};
    }

    &:hover {
      text-decoration: underline;
      background-color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export { Chooser };
